import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

function cls(...xs) {
  return xs.filter(Boolean).join(" ");
}

function Tab({ to, label }) {
  return (
    <NavLink
      to={to}
      end={to === "/admin/ops"}
      className={({ isActive }) =>
        cls(
          "inline-flex h-11 items-center rounded-md border px-5 text-sm font-extrabold transition",
          isActive
            ? "border-slate-900 bg-slate-900 text-white shadow-sm"
            : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
        )
      }
    >
      {label}
    </NavLink>
  );
}

export default function AdminOpsLayout() {
  const location = useLocation();
  const inScheduleTrip =
    location.pathname.startsWith("/admin/ops/trip-requests") ||
    location.pathname.startsWith("/admin/ops/trip-bookings") ||
    location.pathname.startsWith("/admin/ops/trip-setup") ||
    location.pathname.startsWith("/admin/ops/app-version") ||
    location.pathname.startsWith("/admin/ops/vendors");
  const inFlowGuide = location.pathname.startsWith("/admin/ops/flow-guide");

  return (
    <div className="space-y-4">
      <div className="rounded-3xl border border-slate-200 bg-white">
        <div className="border-b border-slate-200 px-5 py-4">
          <div className="text-xs font-bold uppercase tracking-wider text-slate-500">Operations</div>
          <div className="mt-1 text-2xl font-extrabold text-slate-900">Ride Now Ops and Schedule Trip Ops</div>
          <div className="mt-1 text-sm text-slate-600">Operate live demand and scheduled demand independently.</div>
          <div className="mt-3">
            <Tab to="/admin/ops/flow-guide" label="Flow Guide" />
          </div>
        </div>

        <div className="grid gap-4 px-5 py-4 lg:grid-cols-2">
          <div className={cls("rounded-2xl border p-4", !inScheduleTrip && !inFlowGuide ? "border-slate-900 bg-slate-50" : "border-slate-200 bg-white")}>
            <div className="text-[11px] font-bold uppercase tracking-wide text-slate-500">Ride Now Operations</div>
            <div className="mt-1 text-sm text-slate-600">Live requests, accepted bookings, active rides, and cancellation visibility.</div>
            <div className="mt-3 flex flex-wrap gap-2">
              <Tab to="/admin/ops" label="Dashboard" />
              <Tab to="/admin/ops/requests" label="Requests" />
              <Tab to="/admin/ops/bookings" label="Bookings" />
              <Tab to="/admin/ops/rides" label="Rides" />
            </div>
          </div>

          <div className={cls("rounded-2xl border p-4", inScheduleTrip ? "border-slate-900 bg-slate-50" : "border-slate-200 bg-white")}>
            <div className="text-[11px] font-bold uppercase tracking-wide text-slate-500">Schedule Trip Operations</div>
            <div className="mt-1 text-sm text-slate-600">Pure request and booking operations, plus independent scheduled setup and vendor supply control.</div>
            <div className="mt-3 flex flex-wrap gap-2">
              <Tab to="/admin/ops/trip-requests" label="Requests" />
              <Tab to="/admin/ops/trip-bookings" label="Bookings" />
              <Tab to="/admin/ops/trip-setup" label="Setup" />
              <Tab to="/admin/ops/policies" label="Policies" />
              <Tab to="/admin/ops/app-version" label="App Version" />
              <Tab to="/admin/ops/vendors" label="Vendors" />
            </div>
          </div>
        </div>
      </div>

      <Outlet />
    </div>
  );
}
